import { useState, type FormEvent } from 'react';
import { Navigate } from 'react-router';
import { supabaseConfigured } from '../../data/supabase.ts';
import { Button } from '../../ui/Button.tsx';
import { Field } from '../../ui/Field.tsx';
import { CheckCircleIcon } from '../../ui/icons.tsx';
import { useAuth } from './auth-context.ts';

// Login privado (§3): sin registro público ni selección de rol.
export function LoginPage() {
  const { state, signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (state.status === 'ready') return <Navigate to="/" replace />;
  const reason = state.status === 'signedOut' ? state.reason : undefined;

  async function submit(event: FormEvent) {
    event.preventDefault();
    if (email.trim() === '' || password === '') {
      setError('Ingresa tu correo y tu contraseña.');
      return;
    }
    setBusy(true);
    setError(null);
    const message = await signIn(email, password);
    setBusy(false);
    if (message) setError(message);
  }

  return (
    <main className="login">
      <section className="login-hero">
        <div className="brand">
          <span className="brand-mark">
            <img src="/logo.png" alt="" />
          </span>
          <h1 className="brand-name">Miyama Operaciones</h1>
        </div>
        <ul className="login-points">
          <li>
            <CheckCircleIcon />
            Órdenes, diagnóstico y evidencias en un solo lugar
          </li>
          <li>
            <CheckCircleIcon />
            Alertas al técnico y al equipo en cada cambio
          </li>
          <li>
            <CheckCircleIcon />
            Funciona en el teléfono, incluso con mala señal
          </li>
        </ul>
        <p className="login-tagline">Sistema de control de órdenes</p>
      </section>
      <div className="login-panel">
        <div className="login-card">
          <h2>Ingresa a tu cuenta</h2>
          <p className="login-subtitle">Usa el correo que te entregó el administrador.</p>
          {!supabaseConfigured ? (
            <p className="banner banner-error" role="alert">
              La aplicación no está configurada: faltan la URL o la clave del servidor.
            </p>
          ) : null}
          {reason && !error ? (
            <p className="banner banner-warning" role="alert">
              {reason}
            </p>
          ) : null}
          <form className="form" onSubmit={submit} noValidate>
            <Field
              label="Correo"
              type="email"
              autoComplete="username"
              inputMode="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Field
              label="Contraseña"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {error ? (
              <p className="banner banner-error" role="alert">
                {error}
              </p>
            ) : null}
            <Button type="submit" block busy={busy || state.status === 'loading'}>
              Iniciar sesión
            </Button>
          </form>
          <p className="login-help">¿Olvidaste tu contraseña? Pide al administrador que la restablezca.</p>
        </div>
      </div>
    </main>
  );
}
